module.exports = __webpack_public_path__ + "static/media/package-init-json.b75fe66b.png";